import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';

export default function ForgotPasswordPage() {
  useEffect(() => {
    document.title = 'Thunderbolt — Reset Password';
    return () => { document.title = 'Thunderbolt'; };
  }, []);

  const navigate              = useNavigate();
  const [step, setStep]       = useState(1);
  const [email, setEmail]     = useState('');
  const [otp, setOtp]         = useState('');
  const [newPass, setNewPass] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');
  const [msg, setMsg]         = useState('');

  async function handleSendOtp(e) {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email: email.trim().toLowerCase() });
      setMsg('Check your email for a 6-digit code');
      setStep(2);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send code');
    } finally { setLoading(false); }
  }

  async function handleReset(e) {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await api.post('/auth/reset-password', { email: email.trim().toLowerCase(), otp, newPassword: newPass });
      setMsg('Password reset! Please log in.');
      setTimeout(() => navigate('/login'), 1500);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to reset password');
    } finally { setLoading(false); }
  }

  return (
    <div style={s.page}>
      <div style={s.card}>
        <button style={s.back} onClick={() => step === 1 ? navigate('/login') : setStep(1)}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1D1D1F" strokeWidth="2">
            <path d="M19 12H5M12 5l-7 7 7 7"/>
          </svg>
        </button>
        <div style={s.title}>Reset password</div>
        <div style={s.sub}>
          {step === 1
            ? 'Enter your email and we\'ll send you a 6-digit code'
            : `We sent a code to ${email}`}
        </div>

        {error && <div style={s.error}>{error}</div>}
        {msg   && <div style={s.success}>{msg}</div>}

        {step === 1 ? (
          <form onSubmit={handleSendOtp}>
            <div style={s.field}>
              <label style={s.label}>Email address</label>
              <input style={s.input} type="email" placeholder="you@email.com"
                value={email} onChange={e => setEmail(e.target.value)} required/>
            </div>
            <button style={s.btn} type="submit" disabled={loading}>
              {loading ? 'Sending...' : 'Send reset code'}
            </button>
          </form>
        ) : (
          <form onSubmit={handleReset}>
            <div style={s.field}>
              <label style={s.label}>6-digit code</label>
              <input style={{...s.input, fontSize:24, letterSpacing:8, textAlign:'center'}}
                type="text" placeholder="000000" maxLength={6}
                value={otp} onChange={e => setOtp(e.target.value)} required/>
            </div>
            <div style={s.field}>
              <label style={s.label}>New password</label>
              <input style={s.input} type="password" placeholder="At least 8 characters"
                value={newPass} onChange={e => setNewPass(e.target.value)} required/>
            </div>
            <button style={s.btn} type="submit" disabled={loading}>
              {loading ? 'Resetting...' : 'Reset password'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

const s = {
  page:    { minHeight:'100vh', background:'#F5F5F7', display:'flex', alignItems:'center', justifyContent:'center', padding:24 },
  card:    { background:'#fff', borderRadius:24, padding:32, width:'100%', maxWidth:400, boxShadow:'0 4px 40px rgba(0,0,0,0.1)', position:'relative' },
  back:    { position:'absolute', top:20, left:20, width:36, height:36, borderRadius:10, background:'#F5F5F7', border:'none', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer' },
  title:   { fontSize:22, fontWeight:700, color:'#1D1D1F', marginBottom:8, marginTop:12, textAlign:'center' },
  sub:     { fontSize:14, color:'#6E6E73', textAlign:'center', marginBottom:24, lineHeight:1.5 },
  error:   { background:'#FFF0EF', border:'1px solid #FFD0CE', borderRadius:10, padding:'10px 14px', fontSize:13, color:'#FF3B30', marginBottom:16 },
  success: { background:'#E6FAF5', borderRadius:10, padding:'10px 14px', fontSize:13, color:'#00C48C', marginBottom:16 },
  field:   { marginBottom:16 },
  label:   { display:'block', fontSize:13, fontWeight:500, color:'#1D1D1F', marginBottom:6 },
  input:   { width:'100%', padding:'13px 14px', border:'1.5px solid #F0F0F0', borderRadius:12, fontSize:15, background:'#FAFAFA', color:'#1D1D1F', outline:'none', boxSizing:'border-box' },
  btn:     { width:'100%', padding:14, background:'#007AFF', color:'#fff', border:'none', borderRadius:12, fontSize:15, fontWeight:600, cursor:'pointer' },
};
